/**
 * CollapsibleWidget — Jun-2026 (User-Wunsch).
 *
 * Generischer, EINKLAPPBARER Widget-Rahmen mit Titel-Header, optionalem Icon
 * und Zähler-Badge. Der Ein-/Ausklapp-Zustand wird geräteübergreifend
 * gespeichert (useCollapse → DealerProfile.dashboard_collapsed + localStorage).
 */
import { ChevronDown } from "lucide-react";
import { useCollapse } from "../../lib/cockpitCollapse";

export default function CollapsibleWidget({
    collapseKey,
    title,
    icon: Icon,
    count,
    hint,
    defaultCollapsed = false,
    testid,
    children,
}) {
    const [collapsed, toggle] = useCollapse(collapseKey, defaultCollapsed);
    return (
        <div className="bg-white border border-gray-200 rounded-sm overflow-hidden" data-testid={testid}>
            <button
                type="button"
                onClick={toggle}
                className={`w-full px-4 py-3 flex items-center gap-2 hover:bg-gray-50 transition-colors text-left ${!collapsed ? "border-b border-gray-100" : ""}`}
                data-testid={testid ? `${testid}-toggle` : undefined}
                aria-expanded={!collapsed}
            >
                <ChevronDown className={`w-4 h-4 text-gray-400 shrink-0 transition-transform ${collapsed ? "-rotate-90" : ""}`} />
                {Icon && <Icon className="w-4 h-4 text-[#FFCC00] shrink-0" />}
                <h3 className="font-display font-bold text-base truncate">{title}</h3>
                {count != null && (
                    <span className="inline-flex items-center justify-center h-5 px-1.5 rounded-full bg-[#FFCC00] text-[#111827] text-[10px] font-mono-num font-bold leading-none shrink-0">
                        {count}
                    </span>
                )}
                {hint && (
                    <span className="ml-auto text-[10px] text-gray-400 font-normal shrink-0 hidden sm:inline" data-testid={testid ? `${testid}-hint` : undefined}>
                        {hint}
                    </span>
                )}
            </button>
            {!collapsed && <div className="p-4" data-testid={testid ? `${testid}-body` : undefined}>{children}</div>}
        </div>
    );
}
